import Navigation from '../Layout/Navigation';

function Select() {
  return (
    <Navigation showNavItems={false} />
  );
}

export default Select;
